import React, { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";

// Friendly offline notice (web + Capacitor iOS): shows while navigator.onLine is false.
const OfflineBanner = () => {
  const [offline, setOffline] = useState(typeof navigator !== "undefined" && !navigator.onLine);
  const [wasOffline, setWasOffline] = useState(false);
  useEffect(() => {
    const off = () => { setOffline(true); setWasOffline(true); };
    const on = () => { setOffline(false); setTimeout(() => setWasOffline(false), 3500); };
    window.addEventListener("offline", off);
    window.addEventListener("online", on);
    return () => { window.removeEventListener("offline", off); window.removeEventListener("online", on); };
  }, []);
  if (!offline && !wasOffline) return null;
  return (
    <div role="status" aria-live="polite" className={`fixed left-1/2 -translate-x-1/2 bottom-5 z-[120] max-w-[92vw] rounded-full shadow-xl px-5 py-3 text-sm font-bold inline-flex items-center gap-2 bubble-in ${offline ? "bg-[#5a4600] text-white" : "bg-[#63c79a] text-white"}`} data-testid="offline-banner" data-offline={offline ? "true" : "false"}>
      <WifiOff size={16} /> {offline ? "You're offline - lessons still work, and cheers will send when you're back." : "Back online - everything is syncing."}
    </div>
  );
};

export default OfflineBanner;
